import { render, staticRenderFns } from "./JobsLayout.vue?vue&type=template&id=10bc073b&scoped=true"
import script from "./JobsLayout.vue?vue&type=script&lang=js"
export * from "./JobsLayout.vue?vue&type=script&lang=js"
import style0 from "./JobsLayout.vue?vue&type=style&index=0&id=10bc073b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc073b",
  null
  
)

export default component.exports